import React, { useState, useEffect } from "react";
import { getemployeeDetailsApi } from "../../../../Redux/Services";
import Card from "../../../../component/Card/Card";
import "./HRBPDetails.scss";
import { Spinner } from "react-bootstrap";

const HRBPDetailsCard = () => {
    const [isLoading, setIsLoading] = useState(true);
    const [hrbpData, setHrbpData] = useState<any>(null);
    // const employeeObjectID = localStorage.getItem("selectedId");

    const loginUser = localStorage.getItem('login');
    const employeeObjectID = loginUser ? JSON.parse(loginUser).id : null;
    
    //Authorization check logic 
    const role = localStorage.getItem("role");
    const isHR = role?.includes("hr") || role?.includes("employee-db-hrmanager") || role?.includes("employee-db-hrbp") || role?.includes("hr-ta");

    //
    useEffect(() => {
        if (!isHR || !employeeObjectID) {
            setIsLoading(false);
            return;
        }

        const fetchDetails = async () => {
            setIsLoading(true);
            try {
                const response = await getemployeeDetailsApi(employeeObjectID);
                if (response?.success && response.data?.length > 0) {
                    setHrbpData(response.data[0]);
                } else {
                    console.error("Failed to fetch HRBP details or data is empty.");
                }
            } catch (error) {
                console.error("An error occurred while fetching HRBP details:", error);
            } finally {
                setIsLoading(false);
            }
        };

        fetchDetails();
    }, [employeeObjectID, isHR]);

    //Handle authorization check in the return statement
    if (!isHR) {
        return (
            <Card>
                <div className="hrbp-card-details loading-state">
                    <p>You are not authorized to view these details.</p>
                </div>
            </Card>
        );
    }
    
    if (isLoading) {
        return (
            <Card>
                <div className="hrbp-card-details loading-state">
                    {/* <Spinner animation="border" /> */}
                    <p className="mt-2">Loading Reviewer Details...</p>
                </div>
            </Card>
        );
    }

    return (
        <Card>
            <div className="hrbp-card-details">
                <h5 className="title">Nomination Reviewer Details</h5>
                <div className="row g-3">
                    <div className="col-md-6">
                        <div className="detail-item">
                            <p className="detail-item-label">Employee ID</p>
                            <p className="detail-item-value">{hrbpData?.employeeId || 'N/A'}</p>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="detail-item">
                            <p className="detail-item-label">Name</p>
                            <p className="detail-item-value">
                                {`${hrbpData?.candidateName || ''} ${hrbpData?.lastname || ''}`.trim()}
                            </p>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="detail-item">
                            <p className="detail-item-label">Department</p>
                            <p className="detail-item-value">{hrbpData?.department || 'N/A'}</p>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="detail-item">
                            <p className="detail-item-label">Designation</p>
                            <p className="detail-item-value">{hrbpData?.designation || 'N/A'}</p>
                        </div>
                    </div>
                </div>
            </div>
        </Card>
    );
};

export default HRBPDetailsCard;